export default __webpack_public_path__ + "static/media/iconmonstr-check-mark-1.33e31627.svg";